import {PPResponse} from '@gongxigames/framework/integrations/pariplay/response/PPResponse';
import {PPConfiguration} from '@gongxigames/framework/integrations/pariplay/PPConfiguration';

export class PPGetBalanceResponse extends PPResponse {
    public getBalance(): number {
        return PPConfiguration.convertDoubleToInt(this.source.Status.Balance);
    }
}
